export default __webpack_public_path__ + "static/media/2026_Huang_et_al_2026_PlantSoil.e60a212f.pdf";